export default function equalizeElementHeight(container, element) {
  $(container).each(function() {
    let contentHeight = 0;
    
    $(this).find(element).each(function() {
      if ($(this).outerHeight(true) > contentHeight) {
        contentHeight = $(this).outerHeight(true);
      }
    })
    
    $(this).find(element).each(function() {
      $(this).css('min-height', `${contentHeight}px`)
    })
  })
}


// WEBPACK FOOTER //
// ./scripts/util/equalizeElementHeight.js